import { useEffect } from 'react';
import { useParams } from 'react-router';
import { ApiError, usePublicList, useToggleReservation } from '../api';
import { FriendView } from './FriendView';

/** The shareable list at /<slug>. No login. */
export function PublicPage() {
  const { slug = '' } = useParams();
  const query = usePublicList(slug.toLowerCase());
  const toggle = useToggleReservation(slug.toLowerCase());

  useEffect(() => {
    if (query.data) document.title = `${query.data.displayName} zoekt · Monsters`;
  }, [query.data]);

  if (query.data) {
    return (
      <FriendView
        key={query.data.shareSlug}
        list={query.data}
        onToggle={(canId, reserve, friendName) => toggle.mutateAsync({ canId, reserve, friendName })}
      />
    );
  }
  if (query.error) {
    return (
      <div className="center">
        <div className="login">
          <h1 className="login__title">
            MONSTERS
          </h1>
          <p className="card__text">
            {query.error instanceof ApiError && query.error.status === 404
              ? 'Deze zoeklijst bestaat niet (meer). Check de link nog even.'
              : 'De lijst kon niet worden geladen. Probeer het later opnieuw.'}
          </p>
        </div>
      </div>
    );
  }
  return <div className="splash">MONSTERS</div>;
}
